module.exports = __webpack_public_path__ + "ie.svg?bae8083c4528f76f1ab53e7a5ae0bfb2";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ie.svg
// module id = 1084
// module chunks = 27